import {useEffect, useState} from "react";
import axios from "axios";
import {decriptMessage} from "../../../../utils/SecureData";
import {SEARCH_AXIOS_TAMPONI_URL} from "../../../../services/utils/ApiUrls";

export default function useTamponiSearch(query, pageNumber, loadingInitialValue = true) {
	const [loadingSearch, setLoading] = useState(loadingInitialValue);
	const [errorSearch, setError] = useState(false);
	const [rapidiSearch, setRapidi] = useState([]);
	const [hasMoreSearch, setHasMore] = useState(false);
	
	useEffect(() => {
		setRapidi([]);
		if (query.length === 0) {
			setHasMore(false);
		}
	}, [query])
	
	useEffect(() => {
		if (query.length > 0) {
			setLoading(true);
			setError(false);
			let cancel
			axios({
				methods: "GET",
				url: SEARCH_AXIOS_TAMPONI_URL + pageNumber,
				params: {
					search: query
				},
				cancelToken: new axios.CancelToken(c => cancel = c),
				headers: {
					Authorization: "Bearer " + decriptMessage(sessionStorage.getItem("key_asl_to")),
				}
			}).then(response => {
				setRapidi(prevState => {
					let newState = [...prevState, ...response.data];
					return newState.filter(t => t.testTipoDesc !== "Tampone").filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
				})
				setHasMore(response.data.length > 0);
				setLoading(false);
			}).catch((e) => {
				if (axios.isCancel(e)) return
				setError(true)
			})
			
			return () => cancel()
		}
	}, [query, pageNumber, hasMoreSearch])
	
	return {loadingSearch, errorSearch, rapidiSearch, hasMoreSearch};
}
